import { Component, EventEmitter, Input, OnInit, Output, OnChanges } from '@angular/core';
import { AmplifyDialogComponentTextModel } from '../../models/amplify-dialog-component-text.model';
import { ConfigService } from '../../../../Core/Config/services/config.service';
import { LazyLoadEvent } from 'primeng/api';
import { DialogActionButtonModel } from '../../models/dialog-action-button.model';
import { AbstractDialogComponent } from '../../../../Core/Dialogs/components/AbstractDialog/abstract-dialog.component';
import { CoreDialogService } from '../../../../Core/Dialogs/services/dialog.service';
import { DropdownOptionModel } from '../../../Forms/models/dropdown-option.model';
import { ActionKeys } from '../../../Forms/enums/keys.enum';
import { ButtonTypesEnum } from '../../../Forms/enums/button-types.enum';

/* eslint-disable @angular-eslint/no-output-on-prefix */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const AmplifyConstants: any = {
    ellipses: ' ...',
    maxNumberOfChars: 20,
};

@Component({
    selector: 'agpr-amplify-dialog',
    templateUrl: './amplify-dialog.component.html',
    styleUrls: ['./amplify-dialog.component.scss'],
    standalone: false
})
export class AmplifyDialogComponent extends AbstractDialogComponent implements OnChanges, OnInit, LazyLoadEvent {
    readonly buttonTypes = ButtonTypesEnum;

    @Input() public dataSource: any;
    @Input() public display: boolean = false;
    @Input() public isLoading: boolean = false;
    @Input() public dropdownDataSource: DropdownOptionModel[];
    @Input() public minSearchStringSize: number = 3;
    @Input() public localization: AmplifyDialogComponentTextModel = new AmplifyDialogComponentTextModel();
    @Input() public totalRecords: number;
    @Input() public displayRows: number = 5;
    @Input() public userOptions: DialogActionButtonModel[];
    // Icon class to use in the header of the modal
    @Input() public iconClass: string = 'agpr-i-line-bullhorn';
    // Text that will appear as a placeholder in the filter box
    @Input() public filterPlaceholderText: string = null;
    // The delay is in milliseconds (ms)
    @Input() public filterBatchDelay: number = 300;

    // eslint-disable no-output-on-prefix
    @Output() public onUseSelected: EventEmitter<any> = new EventEmitter();
    @Output() public onCancel: EventEmitter<any> = new EventEmitter();
    @Output() public onClose: EventEmitter<any> = new EventEmitter();
    @Output() public onCreateNewStory: EventEmitter<any> = new EventEmitter();
    @Output() public onSearch: EventEmitter<any> = new EventEmitter();
    @Output() public onSelect: EventEmitter<any> = new EventEmitter();
    @Output() public onScroll: EventEmitter<any> = new EventEmitter();
    // eslint=-enable no-output-on-prefix

    // @deprecated: Don't use this anymore, pass in the configurations required
    @Input() public accesswireSelected: boolean = false;

    public isRowSelected: boolean = false;
    public selectedRow: any;
    public keyword: string;
    public isClicked: boolean = false;
    public selectedType: any;
    public first: number = 0;
    public rows: number = 5;
    public selectedOption: DropdownOptionModel;

    private filterTimeout;

    constructor(
        public configService: ConfigService,
        public coreDialogService: CoreDialogService
    ) {
        super(coreDialogService, 'Amplify');
    }

    ngOnInit() {
        this.rows = this.displayRows;

        if (this.accesswireSelected) {
            this.localization.releaseStory = this.localization.releaseWire;
            this.localization.newsroom = this.localization.newswire;
            this.localization.newStory = this.localization.newPressRelease;
            this.iconClass = 'agpr-i-line-globe';
        }

        if (this.dropdownDataSource?.length > 0) {
            this.selectedOption = this.dropdownDataSource[0];
        }
    }

    ngOnChanges() {
        this.selectedRow = {};
        this.isRowSelected = false;
    }

    onUseSelectedClick(): void {
        if (this.selectedRow && this.isRowSelected) {
            this.onUseSelected.emit(this.selectedRow);
        }
        this.resetAmplifyFilters();
    }

    onCancelClick(): void {
        this.resetAmplifyFilters();
        this.onCancel.emit();
        this.closeDialog();
    }

    onCloseClick(): void {
        this.resetAmplifyFilters();
        this.closeDialog();
    }

    onNewStoryClick(): void {
        this.onCreateNewStory.emit();
        this.closeDialog();
    }

    onSearchKeyword(): void {
        this.isClicked = true;
        this.first = 0;
        this.dataSource = null;
        this.onSearch.emit(this.keyword);
    }

    onSelectType(event): void {
        this.dataSource = null;
        this.selectedType = event.value;
        this.keyword = '';
        this.first = 0;
        this.onSelect.emit(event.value);
    }

    isShown(): boolean {
        let isDisplayed: boolean = false;
        if (!this.isClicked && this.keyword && this.keyword.length >= this.minSearchStringSize) {
            isDisplayed = true;
        }
        return isDisplayed;
    }

    onFilterTextChange(): void {
        this.isClicked = false;
        if (this.keyword === '' && this.selectedOption) {
            this.onSelect.emit(this.selectedOption.value);
        }

        if (this.filterTimeout) {
            clearTimeout(this.filterTimeout);
        }

        this.filterTimeout = setTimeout(
            () => {
                this.onSearch.emit(this.keyword);
            }, this.filterBatchDelay
        );
    }

    onRowSelect(story, event?: any): void {
        if (event instanceof KeyboardEvent && !(event.key === ActionKeys.ENTER || event.key === ActionKeys.SPACE)) {
            return;
        }
        this.selectedRow = story;
        this.isRowSelected = true;
    }

    onScrollDataLoad(): void {
        if (this.selectedType) {
            this.keyword = this.keyword;
            this.onScroll.emit(this);
        }
    }

    getContentSnippet(content: string): string {
        if (content.length > AmplifyConstants.maxNumberOfChars) {
            content = content.slice(0, AmplifyConstants.maxNumberOfChars);
            content = content + AmplifyConstants.ellipses;
        }
        return content;
    }

    optionSelected(event, optionIndex) {
        this.userOptions[optionIndex].click.emit();
    }

    public closeDialog(closeAction?: any) {
        this.display = false;
        this.onClose.emit();
    }

    private resetAmplifyFilters(): void {
        this.keyword = '';
        if (this.dropdownDataSource && this.dropdownDataSource.length > 0 ) {
            this.selectedOption = this.dropdownDataSource[0];
        }
        this.dataSource = null;
        this.first = 0;
    }
}
